// src/components/ui/Select.js
import React from 'react';
import * as RadixSelect from '@radix-ui/react-select';

export const Select = ({ children, value, onValueChange }) => (
  <RadixSelect.Root value={value} onValueChange={onValueChange}>
    {children}
  </RadixSelect.Root>
);

export const SelectTrigger = ({ children, className }) => (
  <RadixSelect.Trigger className={`border p-2 rounded ${className}`}>
    {children}
  </RadixSelect.Trigger>
);

export const SelectContent = ({ children, className }) => (
  <RadixSelect.Content className={`border bg-white rounded shadow ${className}`}>
    <RadixSelect.Viewport>{children}</RadixSelect.Viewport>
  </RadixSelect.Content>
);

export const SelectItem = ({ value, children, className }) => (
  <RadixSelect.Item value={value} className={`p-2 hover:bg-gray-100 ${className}`}>
    {children}
  </RadixSelect.Item>
);

export const SelectValue = RadixSelect.Value;
